import { createContext, useState, useContext } from "react";

const DEFAULT_BANK = ""; // Change this to your preferred default
const BankContext = createContext();

export const BankProvider = ({ children }) => {
  const [bank, setBank] = useState(DEFAULT_BANK);
  const [bankConfig, setBankConfig] = useState();

  const updateBank = (nextBank) => {
    console.info("[BankContext] Switching bank", { from: bank || null, to: nextBank });
    setBank(nextBank);
  };

  const updateBankConfig = (key, value) => {
    setBankConfig((prevDetails) => {
      const nextConfig = {
        ...prevDetails,
        [key]: value
      };
      // Log when moving from masked to full details
      if (
        key === "isShowMaskedCardDetails" &&
        typeof prevDetails?.isShowMaskedCardDetails !== "undefined" &&
        prevDetails.isShowMaskedCardDetails === true &&
        value === false
      ) {
        console.info("[BankContext] Switching to full details (isShowMaskedCardDetails=false)");
      }
      return nextConfig;
    });
  };

  return (
    <BankContext.Provider
      value={{
        bank,
        setBank: updateBank,
        updateBankConfig,
        setBankConfig,
        bankConfig,
        
      }}
    >
      {children}
    </BankContext.Provider>
  );
};

export const useBankContext = () => useContext(BankContext);
